import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _278eaaff = () => interopDefault(import('../pages/account.vue' /* webpackChunkName: "pages/account" */))
const _6d88b642 = () => interopDefault(import('../pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _0c0c880a = () => interopDefault(import('../pages/account/credits.vue' /* webpackChunkName: "pages/account/credits" */))
const _1c0d640c = () => interopDefault(import('../pages/account/email.vue' /* webpackChunkName: "pages/account/email" */))
const _d265174c = () => interopDefault(import('../pages/account/plus.vue' /* webpackChunkName: "pages/account/plus" */))
const _75e621b8 = () => interopDefault(import('../pages/account/products.vue' /* webpackChunkName: "pages/account/products" */))
const _27ac3d99 = () => interopDefault(import('../pages/account/profile.vue' /* webpackChunkName: "pages/account/profile" */))
const _4af946be = () => interopDefault(import('../pages/account/wishlists.vue' /* webpackChunkName: "pages/account/wishlists" */))
const _76d6a279 = () => interopDefault(import('../pages/account/redemption/_uuid/index.vue' /* webpackChunkName: "pages/account/redemption/_uuid/index" */))
const _783df850 = () => interopDefault(import('../pages/account/redemption/_uuid/change-plan/index.vue' /* webpackChunkName: "pages/account/redemption/_uuid/change-plan/index" */))
const _eb6b90aa = () => interopDefault(import('../pages/account/redemption/_uuid/change-plan/complete.vue' /* webpackChunkName: "pages/account/redemption/_uuid/change-plan/complete" */))
const _9423cb18 = () => interopDefault(import('../pages/account/redemption/_uuid/change-plan/done.vue' /* webpackChunkName: "pages/account/redemption/_uuid/change-plan/done" */))
const _0df904fb = () => interopDefault(import('../pages/customer-survey.vue' /* webpackChunkName: "pages/customer-survey" */))
const _1d198a09 = () => interopDefault(import('../pages/styleguide.vue' /* webpackChunkName: "pages/styleguide" */))
const _5d4dab8c = () => interopDefault(import('../pages/products/_dealSlug/index.vue' /* webpackChunkName: "pages/products/_dealSlug/index" */))
const _474cba0d = () => interopDefault(import('../pages/products/_dealSlug/questions/_discussionSlug/index.vue' /* webpackChunkName: "pages/products/_dealSlug/questions/_discussionSlug/index" */))
const _638bf950 = () => interopDefault(import('../pages/products/_dealSlug/reviews/_discussionSlug.vue' /* webpackChunkName: "pages/products/_dealSlug/reviews/_discussionSlug" */))
const _155d1793 = () => interopDefault(import('../pages/products/_dealSlug/questions/_discussionSlug/_answerId.vue' /* webpackChunkName: "pages/products/_dealSlug/questions/_discussionSlug/_answerId" */))
const _f26754b8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _e9e1689e = () => interopDefault(import('../pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _278eaaff,
    children: [{
      path: "",
      component: _6d88b642,
      name: "account"
    }, {
      path: "credits",
      component: _0c0c880a,
      name: "account-credits"
    }, {
      path: "email",
      component: _1c0d640c,
      name: "account-email"
    }, {
      path: "plus",
      component: _d265174c,
      name: "account-plus"
    }, {
      path: "products",
      component: _75e621b8,
      name: "account-products"
    }, {
      path: "profile",
      component: _27ac3d99,
      name: "account-profile"
    }, {
      path: "wishlists",
      component: _4af946be,
      name: "account-wishlists"
    }, {
      path: "redemption/:uuid",
      component: _76d6a279,
      name: "account-redemption-uuid"
    }, {
      path: "redemption/:uuid?/change-plan",
      component: _783df850,
      name: "account-redemption-uuid-change-plan"
    }, {
      path: "redemption/:uuid?/change-plan/complete",
      component: _eb6b90aa,
      name: "account-redemption-uuid-change-plan-complete"
    }, {
      path: "redemption/:uuid?/change-plan/done",
      component: _9423cb18,
      name: "account-redemption-uuid-change-plan-done"
    }]
  }, {
    path: "/customer-survey",
    component: _0df904fb,
    name: "customer-survey"
  }, {
    path: "/styleguide",
    component: _1d198a09,
    name: "styleguide"
  }, {
    path: "/products/:dealSlug",
    component: _5d4dab8c,
    name: "products-dealSlug"
  }, {
    path: "/products/:dealSlug?/questions/:discussionSlug",
    component: _474cba0d,
    name: "products-dealSlug-questions-discussionSlug"
  }, {
    path: "/products/:dealSlug?/reviews/:discussionSlug?",
    component: _638bf950,
    name: "products-dealSlug-reviews-discussionSlug"
  }, {
    path: "/products/:dealSlug?/questions/:discussionSlug?/:answerId",
    component: _155d1793,
    name: "products-dealSlug-questions-discussionSlug-answerId"
  }, {
    path: "/",
    component: _f26754b8,
    name: "index"
  }, {
    path: "/*",
    component: _e9e1689e,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config.app && config.app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
